<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户/供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/vendor' }">供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}供应商</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">基础信息</div>
        <el-form-item label="供应商类型：" prop="type">
          <el-col :span="12">
            <el-select v-model="form.type" placeholder="供应商类型" style="margin-right: 0; width: 100%;"
              @change="changeType()">
              <el-option label="公司" value="1"></el-option>
              <el-option label="个人" value="2"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <template v-if="form.type == '2'">
          <el-form-item label="是否公司员工：" prop="is_staff">
            <el-col :span="12">
              <el-radio-group v-model="form.is_staff">
                <el-radio label="1">公司员工</el-radio>
                <el-radio label="2">非公司员工</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </template>

        <el-form-item :label="form.type == 1 ? '供应商名称:' : '姓名:'" prop="vendor">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.vendor" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="身份证号：" prop="id_card" v-show="form.type == 2">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.id_card" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="公司地址：" prop="work_address" v-show="form.type == 1">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.work_address" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="住址：" prop="family_address" v-show="form.type == 2">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.family_address" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="联系人姓名：" prop="name" v-show="form.type == 1">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.name" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="联系人电话：" prop="phone">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.phone" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="联系人邮箱：" prop="email">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.email" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="服务说明：" prop="info">
          <el-col :span="12">
            <el-input style="width: 100%;" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
              v-model="form.info">
            </el-input>
          </el-col>
        </el-form-item>

        <div class="formtitle">收款信息</div>
        <el-form-item label="税率：" prop="rate">
          <el-col :span="12">
            <el-select v-model="form.rate" placeholder="请选择" style="margin-right: 0; width: 100%;">
              <el-option label="0%" value="0"></el-option>
              <el-option label="1%" value="1"></el-option>
              <el-option label="3%" value="3"></el-option>
              <el-option label="6%" value="6"></el-option>
              <el-option label="9%" value="9"></el-option>
              <el-option label="13%" value="13"></el-option>
              <el-option label="20%" value="20"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="收款账户：" prop="payee_name">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.payee_name" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="银行名称：" prop="payee_bank">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.payee_bank" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="银行账号：" prop="payee_bank_account">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.payee_bank_account"
              clearable />
          </el-col>
        </el-form-item>

        <div class="formtitle" v-show="form.type == 1">工商信息</div>
        <el-form-item label="统一社会信用代码：" prop="company_id_card" v-show="form.type == 1">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.company_id_card" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="公司注册地址：" prop="reg_address" v-show="form.type == 1">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.reg_address" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="公司电话：" prop="company_phone" v-show="form.type == 1">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.company_phone" clearable />
          </el-col>
        </el-form-item>

        <template>
          <ul class="anlist">
            <li v-for="(item, index) in fileList" :key="index">
              <div class="abox">
                <el-form-item :label='`附件${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3">
                    <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, item, index)">
                      <el-button size="small" style="width: 100%">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{
                          item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile" target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" icon="el-icon-minus" @click="removeImage(fileList, index)"
                circle></el-button>
            </li>
            <el-button type="primary" style="margin: 0 0 15px 150px;" @click="addImage(fileList)">新增附件</el-button>
          </ul>
        </template>        

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
export default {
  name: 'vendordetail',
  data() {
    return {
      nodeLimtList: [],
      form: {
        type: '1',
        is_staff: '2',
        vendor_id: '',
        vendor: '',
        id_card: '',
        work_address: '',
        family_address: '',
        name: '',
        phone: '',
        email: '',
        info: '',
        rate: '',
        payee_name: '',
        payee_bank: '',
        payee_bank_account: '',
        company_id_card: '',
        reg_address: '',
        company_phone: '',
        atta_str: {},
      },
      p: 1,
      perPage: 30,
      type: '1',//中间值type
      rules1: {
        type: [
          {
            required: true,
            message: '请选择供应商类型',
            trigger: 'change',
          },
        ],
        vendor: [
          {
            required: true,
            message: '请输入供应商名称',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入联系人姓名',
            trigger: 'change',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入联系人电话',
            trigger: 'change',
          },
        ],
        rate: [
          {
            required: true,
            message: '请输入税率',
            trigger: 'change',
          },
        ],
        payee_name: [
          {
            required: true,
            message: '请输入收款账户',
            trigger: 'change',
          },
        ],
        payee_bank: [
          {
            required: true,
            message: '请输入银行名称',
            trigger: 'change',
          },
        ],
        payee_bank_account: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'change',
          },
        ],
        company_id_card: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'change',
          },
        ],
      },
      rules2: {
        type: [
          {
            required: true,
            message: '请选择供应商类型',
            trigger: 'change',
          },
        ],
        is_staff:[
        {
            required: true,
            message: '请选择是否公司员工',
            trigger: 'change',
          },
        ],
        vendor: [
          {
            required: true,
            message: '请输入供应商姓名',
            trigger: 'change',
          },
        ],
        id_card: [
          {
            required: true,
            message: '请输入供应商身份证',
            trigger: 'change',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入联系人电话',
            trigger: 'change',
          },
        ],
        payee_name: [
          {
            required: true,
            message: '请输入收款账户',
            trigger: 'change',
          },
        ],
        payee_bank: [
          {
            required: true,
            message: '请输入银行名称',
            trigger: 'change',
          },
        ],
        payee_bank_account: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'change',
          },
        ],
      },
      rules: {},
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
    this.rules = this.rules1
  },

  watch: {
    'type': {
      handler() {
        //先清空校验结果
        this.$refs['form'].clearValidate()
        if (this.type == 1) {
          this.rules = this.rules1
        } else {
          this.rules = this.rules2
        }
      }
    },
    ['form.payee_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.payee_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
    // ['form.id_card'](val) {
    //   if (val != undefined) {
    //     this.$nextTick(() => {
    //       this.form.id_card = val.replace(/\D/g, '');
    //     });
    //   }
    // },
    ['form.phone'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.phone = val.replace(/\D/g, '');
        });
      }
    },
    ['form.company_phone'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.company_phone = val.replace(/\D/g, '');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    //选择文件
    uploadFile(file, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 2);
      api.uploadFile(formData)
        .then((res) => {
          this.fileList[index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          console.log(this.fileList);
          this.$forceUpdate()
          this.$refs.upFile[index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addImage(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post('apiPurchase_getVendorDetail.html', {
          vendor_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          this.type = form.type
          this.fileList = res.itemArr.fileList.map((item)=> {
            delete item.client_id
            delete item.create_time
            item.flist = []
            return item
          })     
          //防空情况
          if (this.fileList.length === 0) {
            this.fileList = [{origin_name: '', file_name: '', httpFile: '', id: '', flist: []}]
          }
          return (this.form = form)
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateVendor()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateVendor() {//type: 1公司 2个人
      this.form.vendor_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      const form = this.form
      if (form.type == 1) {
        form.id_card = ''
        form.family_address = ''
      }
      if (form.type == 2) {
        form.name = ''
        form.company_id_card = ''
        form.reg_address = ''
        form.company_phone = ''
      }
      //替换掉id为file_id
      let fileList  = this.fileList.map((item) => {
        delete item.flist
        delete item.httpFile
        return item
      })
      const $fileList = fileList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key] || 0
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList = $fileList
      this.$fly
        .post('apiPurchase_addUpdateVendor.html', {
          ...form,
          atta_str: JSON.stringify(fileList),
          atta_del: this.del_atta_list.toString(),
        })
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    changeType() {//改变中间值type 切换rules
      if (this.form.type == 1) {
        this.type = 1
      } else {
        this.type = 2
      }
    },
    getPostData() {
      let postData = {
        p: this.p,
      }
      return postData
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;
    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}
</style>
